import ApiService from "./ApiService"

export async function getEmployeeActivity (data) {
    return ApiService.fetchData({
        url: '/employeeActivity/ActivityHours',
        method: 'post',
        data
    })
}

export async function DispatchCount (data) {
    return ApiService.fetchData({
        url: '/employeeActivity/DispatchCount',
        method: 'post',
        data
    })
}

